import { Navigate, useLocation, useSearchParams } from "react-router-dom";
import { InPanel } from "@/components/common";
import "@/ch.css";

export const can = (u, k) => u.role === "admin" || !!u.perms?.[k];

export function Panel({ title, sub, tabs, id }) {
  const [p, setP] = useSearchParams();
  const vis = tabs.filter((t) => t.show !== false);
  const cur = vis.find((t) => t.k === p.get("tab")) || vis[0];
  if (!cur) return <Navigate to="/" replace />;
  return (
    <div data-testid={`panel-${id}`}>
      <div className="ch chs phd"><h1 className="vh1" data-testid="panel-title">{title}</h1>{sub && <p className="mu">{sub}</p>}
        {vis.length > 1 && <div className="seg2 ptabs" data-testid={`panel-${id}-tabs`}>{vis.map((t) => (
          <span key={t.k} className={cur.k === t.k ? "on" : ""} onClick={() => setP({ tab: t.k })} data-testid={`ptab-${t.k}`}>{t.l}{t.n ? <b> {t.n}</b> : null}</span>))}</div>}</div>
      <InPanel.Provider value={true}><div className="pnl-body" key={cur.k}>{cur.el}</div></InPanel.Provider>
    </div>
  );
}

export function Go({ to, tab }) {
  const { search } = useLocation();
  const p = new URLSearchParams(search);
  if (tab) p.set("tab", tab);
  const s = p.toString();
  return <Navigate to={`${to}${s ? `?${s}` : ""}`} replace />;
}

export function Modal({ onClose, w = 460, id, children }) {
  return (
    <div className="vmod" onMouseDown={(e) => e.target === e.currentTarget && onClose()} data-testid={id}>
      <div className="vmb" style={{ width: `min(${w}px,94vw)` }}>{children}</div>
    </div>
  );
}
